var EOrderStatus;
(function (EOrderStatus) {
    EOrderStatus[EOrderStatus["STATUS_NONE"] = 0] = "STATUS_NONE";
    /**
     * a waiter took the item order
     */
    EOrderStatus[EOrderStatus["STATUS_PRE_ORDERED"] = 1] = "STATUS_PRE_ORDERED";
    /**
     * the waiter sent the item order to the kitchen
     */
    EOrderStatus[EOrderStatus["STATUS_ORDERED"] = 2] = "STATUS_ORDERED";
    /**
     * a cook said he's is working on the item
     */
    EOrderStatus[EOrderStatus["STATUS_CLAIMED"] = 3] = "STATUS_CLAIMED";
    /**
     * the cook said he's done making the item
     */
    EOrderStatus[EOrderStatus["STATUS_PREPARED"] = 4] = "STATUS_PREPARED";
    /**
     * an executive chef or pickup station put the item on a tray
     */
    EOrderStatus[EOrderStatus["STATUS_STAGED"] = 5] = "STATUS_STAGED";
    /**
    * order is on it's way to customer (delivery)
    */
    EOrderStatus[EOrderStatus["STATUS_ON_ROUTE"] = 55] = "STATUS_ON_ROUTE";
    /**
     * The item has been handed off to a customer
     */
    EOrderStatus[EOrderStatus["STATUS_DELIVERED"] = 6] = "STATUS_DELIVERED";
    /**
     * the item order was cancelled after it had advanced to or beyond STATUS_ORDERED
     */
    EOrderStatus[EOrderStatus["STATUS_CANCELLED"] = 7] = "STATUS_CANCELLED";
    /**
     * Used as StatusEvent->status. Not used to set lineitem->status
     */
    EOrderStatus[EOrderStatus["STATUS_EDIT"] = 100] = "STATUS_EDIT";
    /**
     * Used as StatusEvent->status. Not used to set lineitem->status
     */
    EOrderStatus[EOrderStatus["STATUS_RECLAME"] = 101] = "STATUS_RECLAME";
    /**
     * Used as StatusEvent->status. Not used to set lineitem->status
     */
    EOrderStatus[EOrderStatus["STATUS_REMAKE"] = 102] = "STATUS_REMAKE";
    /**
     * Used as StatusEvent->status. Not used to set lineitem->status
     */
    EOrderStatus[EOrderStatus["STATUS_DISCOUNT_ADD"] = 103] = "STATUS_DISCOUNT_ADD";
    /**
     * Used as StatusEvent->status. Not used to set lineitem->status
     */
    EOrderStatus[EOrderStatus["STATUS_DISCOUNT_DEL"] = 104] = "STATUS_DISCOUNT_DEL";
    /**
     * Used as StatusEvent->status. Not used to set lineitem->status
     */
    EOrderStatus[EOrderStatus["STATUS_REROUTED_TO"] = 107] = "STATUS_REROUTED_TO";
    /**
     * Used as StatusEvent->status. Not used to set lineitem->status
     */
    EOrderStatus[EOrderStatus["STATUS_REROUTED_FROM"] = 108] = "STATUS_REROUTED_FROM";
    /**
     * Used as StatusEvent->status. Not used to set lineitem->status
     */
    EOrderStatus[EOrderStatus["STATUS_REFUNDED"] = 109] = "STATUS_REFUNDED";
})(EOrderStatus || (EOrderStatus = {}));
export default EOrderStatus;



//////////////////
// WEBPACK FOOTER
// ./src/models/interfaces/Orders/EOrderStatus.ts
// module id = 6qQQ
// module chunks = 18